import { render } from "./MultipleChoiceField.vue?vue&type=template&id=6b677fe8&scoped=true"
import script from "./MultipleChoiceField.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceField.vue?vue&type=script&lang=js"

import "./MultipleChoiceField.vue?vue&type=style&index=0&id=6b677fe8&scoped=true&lang=css"

import exportComponent from "c:\\Clients\\VoterFly\\application\\VoterFly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b677fe8"]])

export default __exports__